import React, { useMemo } from "react"
import { animated, useSpring } from "react-spring"
import {
  ChartIcon,
  DashboardIcon,
  GroupIcon,
  HouseIcon,
  PinIcon,
} from "../assets/icons"
import routes from "../routing/routes"
import useParamNavigation from "../utils/navigation"
import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"
import useDeviceType from "../utils/useDeviceType"
import { bounceFromBottom, inflateFromRight } from "./Animations"
import { Avatar } from "./TitleHeader"

const Navigation = () => {
  const { pathWithPropId } = useParamNavigation()
  const { t } = useTranslation()
  const { isMobileView, isDesktopView } = useDeviceType()
  const pageTransition = useSpring(inflateFromRight)
  const navbarTransition = useSpring(bounceFromBottom)

  const options = [
    {
      title: "labels.dashboard",
      icon: <DashboardIcon className="gray-svg w-6" />,
      path: routes["main-shell"].children["home"].path,
      class: ''
    },
    {
      title: "labels.home",
      icon: <HouseIcon className="gray-svg w-6" />,
      path: routes["main-shell"].children["property-details"].path,
      class: 'casa-section-tag'
    },
    {
      title: "labels.area",
      icon: <PinIcon className="gray-svg w-6" />,
      path: routes["main-shell"].children["your-area"].path,
      class: 'area-section-tag',
    },
    {
      title: "labels.finances",
      icon: <ChartIcon className="gray-svg w-6" />,
      path: routes["main-shell"].children["finances"].path,
      class: 'value-section-tag',
    },
  ]

  const NavigationItem = (title, icon, path, className, disable) => {
    const isSelected = useMemo(() => {
      return window.location.pathname.split("/").pop() === path
    }, [window.location.pathname, path])

    return (
      <NavLink
      to={disable ? "#" : pathWithPropId(path)}
        className={clsx(
          "flex items-center w-full",
          className,
          isSelected && "blue-svg",
          isMobileView && "flex-col items-center",
          isDesktopView && "gap-2"
        )}
        key={`bottom-nav-${title}`}
      >
        {icon}
        <div
          className={clsx(
            "text-xs",
            isSelected ? "text-accumin-primary-electric-blue font-semibold" : "text-accumin-neutral-300"
          )}
        >
          {t(title)}
        </div>
      </NavLink>
    )
  }

  return (
    <>
      <animated.div
        className={clsx(
          "w-full bg-white ",
          isMobileView && "fixed bottom-0 shadow-inner-top px-3 pt-3 pb-5",
          isDesktopView && "shadow-inner-bottom page-header items-center z-50"
        )}
        style={isMobileView ? pageTransition : navbarTransition}
      >
        <div className={clsx(isDesktopView && "max-w-[960px] mx-auto flex")}>
          {isDesktopView && <Avatar />}
          <div
            className={clsx(
              isMobileView && "grid grid-cols-5 w-full",
              isDesktopView && "flex gap-8 max-w-[50%] mx-auto"
            )}
          >
            {options.map((option) =>
              NavigationItem(
                option.title,
                option.icon,
                option.path,
                option.class,
                option.disable
              )
            )}
            {NavigationItem(
              "labels.more",
              <GroupIcon className="gray-svg w-6"></GroupIcon>,
              "more"
            )}
          </div>
        </div>
      </animated.div>
    </>
  )
}

export default Navigation
